<template>
  <div>
    <v-autocomplete
      v-model="tags"
      :items="tagOptions"
      item-text="label"
      item-value="id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { RISK_CATEGORY_TAGS } from "@/common/constants/riskCategoryTags.js";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};
export default {
  name: "RiskCategoryTag",
  props: {
    selectedTags: {
      type: String,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      search: "",
      label: "Tag Filter",
      tags: [],
    };
  },
  computed: {
    tagOptions() {
      const filteredList = RISK_CATEGORY_TAGS.filter((tag) => {
        if (
          (tag.isCyber && this.featureUnlocked(`risk-category-cyber`)) ||
          !tag.isCyber
        ) {
          return tag;
        }
      });

      return filteredList.sort(function (a, b) {
        let nameA = a.label.toLowerCase();
        let nameB = b.label.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
  },
  mounted() {
    if (this.selectedTags) {
      this.tags = this.selectedTags.split(",");
    }
  },
  watch: {
    tags: {
      handler(newVal) {
        let selected = newVal.join(",");
        this.$emit(EMITTED_ACTIONS.CHANGE, {
          selectedTags: selected,
        });
      },
      deep: true,
    },
    reset: {
      handler() {
        this.tags = [];
      },
    },
  },
};
</script>

<style scoped></style>
